import { resources } from "@constants/hardcoded-strings";
import { LabelWidthTypes } from "@enums/label-width-types";
import { LayoutTypes } from "@enums/layout-types";
import { FormattedVerificationTransactionDetails } from "@idw-types/data/verification-transaction-details";
import { LabelValueContainer } from "../../../common/label-value-container/label-value-container";
import styles from "./verification-transaction-details-component.less";

type VerificationTransactionDetailsComponentProps = {
    verificationTransactionDetails: FormattedVerificationTransactionDetails;
};

export const VerificationTransactionDetailsComponent = (props: VerificationTransactionDetailsComponentProps) => {
    const { verificationTransactionDetails } = props;

    return (
        <div className={styles.verificationTransactionDetailsComponent}>
            <div className={styles.textContainer}>
                <div className={styles.twoColumnContainer}>
                    <LabelValueContainer
                        controlId="verification-name-label-value"
                        label={resources.pages.verificationTransactionDetails.labels.verificationServiceName.label}
                        labelWidth={LabelWidthTypes.EXTRA_SMALL}
                        layout={LayoutTypes.COLUMN}
                        value={verificationTransactionDetails.serviceName}
                        labelIsBold={true}
                    />
                    <LabelValueContainer
                        controlId="apikey-label-value"
                        label={resources.pages.verificationTransactionDetails.labels.apiKey.label}
                        labelWidth={LabelWidthTypes.EXTRA_SMALL}
                        layout={LayoutTypes.COLUMN}
                        value={verificationTransactionDetails.apiKey}
                        labelIsBold={true}
                    />
                </div>
                <div className={styles.twoColumnContainer}>
                    <LabelValueContainer
                        controlId="transaction-id-label-value"
                        label={resources.pages.verificationTransactionDetails.labels.transactionId.label}
                        labelWidth={LabelWidthTypes.EXTRA_SMALL}
                        layout={LayoutTypes.COLUMN}
                        value={verificationTransactionDetails.asi}
                        labelIsBold={true}
                    />
                    <LabelValueContainer
                        controlId="relying-party-label-value"
                        label={resources.pages.verificationTransactionDetails.labels.relyingParty.label}
                        labelWidth={LabelWidthTypes.EXTRA_SMALL}
                        layout={LayoutTypes.COLUMN}
                        value={verificationTransactionDetails.relyingParty?.name}
                        labelIsBold={true}
                    />
                </div>
                <div className={styles.twoColumnContainer}>
                    <LabelValueContainer
                        controlId="userMBUN-label-value"
                        label={resources.pages.verificationTransactionDetails.labels.userMBUN.label}
                        labelWidth={LabelWidthTypes.EXTRA_SMALL}
                        layout={LayoutTypes.COLUMN}
                        value={verificationTransactionDetails.mbun}
                        labelIsBold={true}
                    />
                    <LabelValueContainer
                        controlId="user-credential-label-value"
                        label={resources.pages.verificationTransactionDetails.labels.userCredential.label}
                        labelWidth={LabelWidthTypes.EXTRA_SMALL}
                        layout={LayoutTypes.COLUMN}
                        value={verificationTransactionDetails.credential}
                        labelIsBold={true}
                    />
                </div>
                <div className={styles.twoColumnContainer}>
                    <LabelValueContainer
                        controlId="session-key-label-value"
                        label={resources.pages.verificationTransactionDetails.labels.sessionKey.label}
                        labelWidth={LabelWidthTypes.EXTRA_SMALL}
                        layout={LayoutTypes.COLUMN}
                        value={verificationTransactionDetails.sessionKey}
                        labelIsBold={true}
                    />
                    <LabelValueContainer
                        controlId="appid-label-value"
                        label={resources.pages.verificationTransactionDetails.labels.appId.label}
                        labelWidth={LabelWidthTypes.EXTRA_SMALL}
                        layout={LayoutTypes.COLUMN}
                        value={verificationTransactionDetails.appID}
                        labelIsBold={true}
                    />
                </div>
                <div className={styles.twoColumnContainer}>
                    <LabelValueContainer
                        controlId="workflow-label-value"
                        label={resources.pages.verificationTransactionDetails.labels.workflow.label}
                        labelWidth={LabelWidthTypes.EXTRA_SMALL}
                        layout={LayoutTypes.COLUMN}
                        value={verificationTransactionDetails.workflow?.name}
                        labelIsBold={true}
                    />

                    <LabelValueContainer
                        controlId="country-label-value"
                        label={resources.pages.verificationTransactionDetails.labels.country.label}
                        labelWidth={LabelWidthTypes.EXTRA_SMALL}
                        layout={LayoutTypes.COLUMN}
                        value={verificationTransactionDetails.country}
                        labelIsBold={true}
                    />
                </div>
            </div>

        </div>
    )
};